import { render, staticRenderFns } from "./reservados.vue?vue&type=template&id=935277c0"
import script from "./reservados.vue?vue&type=script&lang=js"
export * from "./reservados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports